import camelcaseKeys from 'camelcase-keys';
function normalizeObjectKey(key) {
    if (!key.includes('_')) {
        return key;
    }
    return Object.keys(camelcaseKeys({
        [key]: true
    }, {
        deep: false
    }))[0];
}
export function stripNullObjectProperties(value) {
    if (Array.isArray(value)) {
        return value.map((item) => stripNullObjectProperties(item));
    }
    if (typeof value !== 'object' || value === null) {
        return value;
    }
    const normalizedEntries = Object.entries(value).flatMap(([key, itemValue]) => {
        if (itemValue === null) {
            return [];
        }
        return [[normalizeObjectKey(key), stripNullObjectProperties(itemValue)]];
    });
    return Object.fromEntries(normalizedEntries);
}
export function normalizeKeys(value) {
    if (Array.isArray(value)) {
        return value.map((item) => normalizeKeys(item));
    }
    if (typeof value !== 'object' || value === null) {
        return value;
    }
    const normalizedEntries = Object.entries(value).map(([key, itemValue]) => [
        normalizeObjectKey(key),
        normalizeKeys(itemValue)
    ]);
    return Object.fromEntries(normalizedEntries);
}
